import React from 'react';
import './ToggleSelectOption.scss';

export const ToggleSelectOption = ({ option, value, onChange }) => (
    <div
        className={
            isOptionSelected(option, value) ? 'option selected' : 'option'
        }
        onClick={() => onChange(option)}
    >
        <i className={'material-icons'}>format_align_justify</i>
        <span>{option.label}</span>
    </div>
);

const isOptionSelected = (option, selectedOption) =>
    option.value === selectedOption;
